var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_612",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 612",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 506.976,
    height: 81.419,
    viewBox: "0 0 506.976 81.419",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_409",
    "data-name": "\\u9577\\u65B9\\u5F62 409",
    width: 506.976,
    height: 81.419,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_611",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 611",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_494",
    "data-name": "\\u30D1\\u30B9 494",
    d: "M31.3,81.419V35.162H20.864a5.38,5.38,0,0,0-3.7,1.344,4.148,4.148,0,0,0-1.512,3.2V81.419H0V39.88A16.882,16.882,0,0,1,6.1,26.789a21.849,21.849,0,0,1,14.762-5.5H78.24V81.419H62.592V35.162H46.944V81.419Z",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_406",
    "data-name": "\\u9577\\u65B9\\u5F62 406",
    width: 15.648,
    height: 60.134,
    transform: "translate(83.456 21.285)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_495",
    "data-name": "\\u30D1\\u30B9 495",
    d: "M104.319,21.285h52.16a21.849,21.849,0,0,1,14.762,5.5,16.882,16.882,0,0,1,6.1,13.091V81.419H161.7V39.788a3.963,3.963,0,0,0-1.461-3.053A5.7,5.7,0,0,0,157,35.254H119.967V81.419H104.319Z",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_496",
    "data-name": "\\u30D1\\u30B9 496",
    d: "M188.819,76a16.765,16.765,0,0,1-6.156-13.019V39.816A16.855,16.855,0,0,1,188.819,26.7a21.5,21.5,0,0,1,14.709-5.42l36.511-.093A21.83,21.83,0,0,1,254.8,26.7a16.917,16.917,0,0,1,6.1,13.111V62.98A16.825,16.825,0,0,1,254.8,76a21.457,21.457,0,0,1-14.762,5.42H203.528A21.5,21.5,0,0,1,188.819,76m54.924-9.8a4.137,4.137,0,0,0,1.513-3.192V39.788a3.764,3.764,0,0,0-1.356-2.822,6.517,6.517,0,0,0-2.921-1.619,2.686,2.686,0,0,1-.47-.046,2.713,2.713,0,0,0-.47-.047H203.528a8.737,8.737,0,0,0-1.044.322,7.868,7.868,0,0,0-1.252.6,6.337,6.337,0,0,0-2.034,1.564,3.279,3.279,0,0,0-.887,2.207v22.9a4.016,4.016,0,0,0,1.461,3.128,6.278,6.278,0,0,0,3.234,1.564h37.033a5.381,5.381,0,0,0,3.7-1.341",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_497",
    "data-name": "\\u30D1\\u30B9 497",
    d: "M266.118,21.285h52.16a21.847,21.847,0,0,1,14.762,5.5,16.882,16.882,0,0,1,6.1,13.091V81.419H323.494V39.788a3.963,3.963,0,0,0-1.461-3.053,5.7,5.7,0,0,0-3.233-1.481H281.765V81.419H266.118Z",
    fill: "#989899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_498",
    "data-name": "\\u30D1\\u30B9 498",
    d: "M344.334,21.285h52.159a21.845,21.845,0,0,1,14.762,5.5,16.884,16.884,0,0,1,6.1,13.091V81.419h-15.65V39.788a3.962,3.962,0,0,0-1.46-3.053,5.7,5.7,0,0,0-3.233-1.481H359.981V81.419H344.334Z",
    fill: "#989899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_499",
    "data-name": "\\u30D1\\u30B9 499",
    d: "M489.337,21.285,451.663,76.064c-1.431,1.864-4.781,3.736-6.589,4.384a17.851,17.851,0,0,1-6.051.971,16.14,16.14,0,0,1-11.006-4.07,12.508,12.508,0,0,1-4.642-9.714V21.285h15.648V62.056a1.784,1.784,0,0,0,.677,1.528,2.461,2.461,0,0,0,1.513.509c.14,0,.21.015.21.046v.416c0,.062.086.015.261-.139l1.094-.972,28.636-42.159Z",
    fill: "#989899"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_407",
    "data-name": "\\u9577\\u65B9\\u5F62 407",
    width: 15.647,
    height: 60.134,
    transform: "translate(491.329 21.285)",
    fill: "#989899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_500",
    "data-name": "\\u30D1\\u30B9 500",
    d: "M506.977,8.164A8.023,8.023,0,1,1,498.955.141a8.021,8.021,0,0,1,8.022,8.023",
    fill: "#ef7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_501",
    "data-name": "\\u30D1\\u30B9 501",
    d: "M99.122,8.022A8.022,8.022,0,1,1,91.1,0a8.021,8.021,0,0,1,8.022,8.022",
    fill: "#dc000c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_408",
    "data-name": "\\u9577\\u65B9\\u5F62 408",
    width: 51.141,
    height: 12.893,
    transform: "translate(355.256 44.549)",
    fill: "#989899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_502",
    "data-name": "\\u30D1\\u30B9 502",
    d: "M438.373,61.659s1.235,3.221,3.3,2.068c1.88-1.048,4.23-4.66,4.23-4.66l.573,1.809,1.253,4.047s-2.47,4.333-3.331,4.225-10.743-1.218-10.743-1.218l.967-5.586Z",
    fill: "#989899"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLogo);
export default __webpack_public_path__ + "static/media/black_logo.ea101fdd1539fdab87ca94122b70ff27.svg";
export { ForwardRef as ReactComponent };